export default __webpack_public_path__ + "static/media/product01.3b10f843.png";